import { DevApp } from './DevApp';

export default DevApp;